import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './UsuariosMaster.module.css';
import { MdPeople, MdSearch, MdDelete, MdAdminPanelSettings, MdPerson, MdArrowUpward, MdArrowDownward } from "react-icons/md";
import { UsuariosContext } from '../../../shared/contexts/UsuariosContext';

function UsuariosMaster() {
    const { usuarios, loading, fetchUsuarios } = useContext(UsuariosContext);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterTipo, setFilterTipo] = useState('todos');

    // Buscar usuários quando a página montar
    useEffect(() => {
        fetchUsuarios();
    }, []);

    const handleAlterarPermissoes = async (id, tipoAtual) => {
        const novoTipo = tipoAtual === 'admin' ? 'master' : 'admin';
        const acao = novoTipo === 'master' ? 'promover para Master' : 'rebaixar para Admin';

        if (window.confirm(`Tem certeza que deseja ${acao} este usuário?`)) {
            try {
                const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
                const token = localStorage.getItem('token');

                await axios.patch(
                    `${API_URL}/master/usuarios/${id}/permissoes`,
                    { novoTipo },
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );

                alert(`Permissões alteradas com sucesso! Usuário agora é ${novoTipo}.`);
                fetchUsuarios();
            } catch (error) {
                console.error("Erro ao alterar permissões:", error);
                const errorMsg = error.response?.data?.error || "Erro ao alterar permissões. Tente novamente.";
                alert(errorMsg);
            }
        }
    };

    const handleDelete = async (id, tipo) => {
        if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
            try {
                const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
                const token = localStorage.getItem('token');

                await axios.delete(`${API_URL}/master/usuarios/${id}?tipo=${tipo}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                fetchUsuarios();
            } catch (error) {
                console.error("Erro ao excluir usuário:", error);
                alert("Erro ao excluir usuário. Tente novamente.");
            }
        }
    };

    const filteredUsuarios = usuarios.filter(user => {
        const matchSearch =
            user.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.telefone?.includes(searchTerm);

        const matchTipo =
            filterTipo === 'todos' ||
            (filterTipo === 'admin' && user.tipo_usuario === 'admin') ||
            (filterTipo === 'master' && user.tipo_usuario === 'master') ||
            (filterTipo === 'cliente' && user.tipo_usuario === 'cliente') ||
            (filterTipo === 'atendente' && user.tipo_usuario === 'atendente');

        return matchSearch && matchTipo;
    });

    const getTipoBadge = (tipo) => {
        const badges = {
            admin: <span className={styles.badgeAdmin}>Admin</span>,
            cliente: <span className={styles.badgeCliente}>Cliente</span>,
            atendente: <span className={styles.badgeAtendente}>Atendente</span>,
            master: <span className={styles.badgeMaster}>Master</span>
        };
        return badges[tipo] || <span className={styles.badgeCliente}>{tipo}</span>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };

    return (
        <div className={styles.secaoPrincipal}>
            <SideBarMaster />
            <div className={styles.containerDashboard}>
                <HeaderMaster />

                <div className={styles.contentDashboard}>
                    <div className={styles.tituloSecao}>
                        <div>
                            <h2>Gestão de Usuários</h2>
                        </div>
                    </div>

                    <div className={styles.filtersContainer}>
                        <div className={styles.searchBar}>
                            <MdSearch className={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Pesquisar por nome, email ou telefone..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className={styles.searchInput}
                            />
                        </div>

                        <div className={styles.tipoFilter}>
                            <button
                                className={filterTipo === 'todos' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterTipo('todos')}
                            >
                                Todos
                            </button>
                            <button
                                className={filterTipo === 'master' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterTipo('master')}
                            >
                                Masters
                            </button>
                            <button
                                className={filterTipo === 'admin' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterTipo('admin')}
                            >
                                Administradores
                            </button>
                            <button
                                className={filterTipo === 'cliente' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterTipo('cliente')}
                            >
                                Clientes
                            </button>
                            <button
                                className={filterTipo === 'atendente' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterTipo('atendente')}
                            >
                                Atendentes
                            </button>
                        </div>
                    </div>

                    <div className={styles.statsCards}>
                        <div className={styles.statCard}>
                            <h3>Total de Usuários</h3>
                            <p className={styles.statNumber}>{usuarios.length}</p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Masters</h3>
                            <p className={styles.statNumber}>
                                {usuarios.filter(u => u.tipo_usuario === 'master').length}
                            </p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Administradores</h3>
                            <p className={styles.statNumber}>
                                {usuarios.filter(u => u.tipo_usuario === 'admin').length}
                            </p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Clientes</h3>
                            <p className={styles.statNumber}>
                                {usuarios.filter(u => u.tipo_usuario === 'cliente').length}
                            </p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Atendentes</h3>
                            <p className={styles.statNumber}>
                                {usuarios.filter(u => u.tipo_usuario === 'atendente').length}
                            </p>
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        {loading ? (
                            <p className={styles.loading}>Carregando...</p>
                        ) : (
                            <>
                                {/* Tabela para desktop */}
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome</th>
                                            <th>Email</th>
                                            <th>Telefone</th>
                                            <th>Tipo</th>
                                            <th>Cadastro</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsuarios.length > 0 ? (
                                            filteredUsuarios.map(user => (
                                                <tr key={`${user.tipo_usuario}-${user.id}`}>
                                                    <td>{user.id}</td>
                                                    <td className={styles.nomeUsuario}>
                                                        {user.tipo_usuario === 'admin' ? (
                                                            <MdAdminPanelSettings className={styles.iconTable} />
                                                        ) : (
                                                            <MdPerson className={styles.iconTable} />
                                                        )}
                                                        {user.nome}
                                                    </td>
                                                    <td>{user.email}</td>
                                                    <td>{user.telefone || 'N/A'}</td>
                                                    <td>{getTipoBadge(user.tipo_usuario)}</td>
                                                    <td>{formatDate(user.data_cadastro)}</td>
                                                    <td>
                                                        <div className={styles.actionButtons}>
                                                            {(user.tipo_usuario === 'admin' || user.tipo_usuario === 'master') && (
                                                                <button
                                                                    className={user.tipo_usuario === 'admin' ? styles.btnPromote : styles.btnDemote}
                                                                    onClick={() => handleAlterarPermissoes(user.id, user.tipo_usuario)}
                                                                    title={user.tipo_usuario === 'admin' ? 'Promover para Master' : 'Rebaixar para Admin'}
                                                                >
                                                                    {user.tipo_usuario === 'admin' ? <MdArrowUpward /> : <MdArrowDownward />}
                                                                </button>
                                                            )}
                                                            {user.tipo_usuario !== 'master' && (
                                                                <button
                                                                    className={styles.btnDelete}
                                                                    onClick={() => handleDelete(user.id, user.tipo_usuario)}
                                                                    title="Excluir"
                                                                >
                                                                    <MdDelete />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className={styles.noData}>
                                                    Nenhum usuário encontrado
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Cards para mobile */}
                                <div className={styles.cardsContainer}>
                                    {filteredUsuarios.length > 0 ? (
                                        filteredUsuarios.map(user => (
                                            <div key={`${user.tipo_usuario}-${user.id}`} className={styles.card}>
                                                <div className={styles.cardHeader}>
                                                    <div className={styles.cardTitle}>
                                                        {user.tipo_usuario === 'admin' ? (
                                                            <MdAdminPanelSettings className={styles.cardIcon} />
                                                        ) : (
                                                            <MdPerson className={styles.cardIcon} />
                                                        )}
                                                        <h3>{user.nome}</h3>
                                                    </div>
                                                    {getTipoBadge(user.tipo_usuario)}
                                                </div>

                                                <div className={styles.cardBody}>
                                                    <div className={styles.cardRow}>
                                                        <strong>ID:</strong>
                                                        <span>{user.id}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Email:</strong>
                                                        <span>{user.email}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Telefone:</strong>
                                                        <span>{user.telefone || 'N/A'}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Cadastro:</strong>
                                                        <span>{formatDate(user.data_cadastro)}</span>
                                                    </div>
                                                </div>

                                                <div className={styles.cardFooter}>
                                                    {(user.tipo_usuario === 'admin' || user.tipo_usuario === 'master') && (
                                                        <button
                                                            className={user.tipo_usuario === 'admin' ? styles.btnPromote : styles.btnDemote}
                                                            onClick={() => handleAlterarPermissoes(user.id, user.tipo_usuario)}
                                                        >
                                                            {user.tipo_usuario === 'admin' ? <MdArrowUpward /> : <MdArrowDownward />}
                                                            <span>{user.tipo_usuario === 'admin' ? 'Promover' : 'Rebaixar'}</span>
                                                        </button>
                                                    )}
                                                    {user.tipo_usuario !== 'master' && (
                                                        <button
                                                            className={styles.btnDelete}
                                                            onClick={() => handleDelete(user.id, user.tipo_usuario)}
                                                        >
                                                            <MdDelete />
                                                            <span>Excluir</span>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className={styles.noData}>Nenhum usuário encontrado</p>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <FooterNavigationMaster />
        </div>
    );
}

export default UsuariosMaster;
